import { render, staticRenderFns } from "./PromotionRecommendation.vue?vue&type=template&id=3478afda&"
import script from "./PromotionRecommendation.vue?vue&type=script&lang=ts&"
export * from "./PromotionRecommendation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports